var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-description',{attrs:{"path":[
      { label: 'Modèle contrat', route: 'contrats' },
      { label: 'PV entré', route: 'pventre' },
      { label: 'PV sortie', route: 'pvsortie' },
    ]}}),(_vm.path == '')?_c('Contrat'):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }